export default "__VITE_ASSET__C7vU3OcM__"